import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const OrderSetAddModal = () => {

    const navigate = useNavigate();
    const [platformTypeData, setPlatformTypeData] = useState([]);



    useEffect(() => {
        fetch(`https://api.velormall.com/api/admin/platform-type/all/view`, {
            method: "GET",
        })
            .then((res) => res.json())
            .then((data) => {
                setPlatformTypeData(data.data);
            });
    }, []);


    const refSubmitDis = useRef();
    const [errorMessage, setErrorMessage] = useState({});


    const handleSubmitData = (event) => {
        event.preventDefault();
        refSubmitDis.current.setAttribute("disabled", true);
        // Clear previous errors
        setErrorMessage({});

        try {
            const formData = new FormData(event.currentTarget);
            const config = {
                headers: {
                    "content-type": "application/json",
                },
            };
            axios
                .post(
                    `https://api.velormall.com/api/admin/order-set/create`,
                    formData,
                    config
                )
                .then((response) => {
                    const data = response?.data;
                    if (data?.success) {
                         navigate(`/admin/order-set/edit/${data?.data?._id}`);
                        event.target.reset();
                        toast.success(`${response?.data.message}`, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                        refSubmitDis.current.removeAttribute("disabled");

                    }
                })
                .then((data) => {
                    toast.success(`${data.message}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                })
                .catch((error) => {
                    setErrorMessage(error?.response?.data?.errors)
                    refSubmitDis.current.removeAttribute("disabled");
                });
        } catch (error) {

        }
    };


    return (
        <>
            <Modal.Body>
                <form onSubmit={handleSubmitData}>
                    <div class="modal-body">
                        <div class="form-group">
                            <label htmlFor="name" class="required">
                                Name
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                name="name"
                                id="name"
                            />
                            {errorMessage?.name && (
                                <span className="text-danger pt-2">
                                    {errorMessage?.name?.msg}
                                </span>
                            )}
                        </div>


                        <div className="form-group">
                            <label htmlFor="role" className="required">Platform </label>
                            <select className="form-control" name="platformTypeId" id="role"
                            >
                                <option value="" disabled selected>Select Platform </option>

                                {platformTypeData.map((item) => (
                                    <option key={item?._id} value={item?._id}>
                                        {item?.name}
                                    </option>
                                ))}
                            </select>
                            {errorMessage?.platformTypeId && (
                                <span className="text-danger pt-2">
                                    {errorMessage?.platformTypeId?.msg}
                                </span>
                            )}
                        </div>

                        <button
                            type="submit"
                            ref={refSubmitDis}
                            class="btn btn-primary w-100 h-45"
                        >
                            Submit
                        </button>
                    </div>
                </form>
            </Modal.Body>
        </>
    );
};

export default OrderSetAddModal;